"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.callCompletion = exports.getContextPromise = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const standard_1 = require("react-hook-schema/standard");
const copilot_js_1 = require("copilot-js");
const react_hook_form_1 = require("react-hook-form");
const fromFetchSSEStream_1 = require("copilot-js/dist/helpers/fromFetchSSEStream");
const events_1 = __importDefault(require("events"));
const wordTable_1 = require("./hooks/wordTable");
const api_1 = require("./copilotApi/api");
const util_1 = require("./copilotApi/util");
const Proofreading_1 = require("./copilotApi/Proofreading");
const CopilotSetting_1 = require("./copilotApi/CopilotSetting");
const showKeyboard_1 = require("./copilotApi/showKeyboard");
const models_hook_1 = require("app/models.hook");
const referenceTranslationIdMatcher_1 = require("@/utils/referenceTranslationIdMatcher");
const hooks_1 = require("@mantine/hooks");
const components_1 = require("utils/components");
const shortcutHandler_1 = require("utils/shortcutHandler");
const CopilotContextList_1 = require("./copilotApi/CopilotContextList");
const AnotherTranslationList_1 = require("./copilotApi/AnotherTranslationList");
const reportTokenUsage_1 = require("@/utils/reportTokenUsage");
const useDirectWordReplacement = true;
function isIdMatch(ignoredReferenceTranslationIds, id) {
    return ignoredReferenceTranslationIds.some((ignoreId) => (0, referenceTranslationIdMatcher_1.isIgnoredReferenceTranslationIdMatchesReferenceId)(ignoreId, id));
}
const getContextPromise = (_a) => __awaiter(void 0, [_a], void 0, function* ({ searchFromProject, searchFromSegmentTable, langId, projectId, schema, textValue, searchFromPrevScripts, controller, callback, }) {
    var _b, _c, _d;
    const { ignoreExactMatchedReference } = JSON.parse(localStorage.getItem("personalData") || "{}");
    const segmentTableScripts = (_b = searchFromSegmentTable === null || searchFromSegmentTable === void 0 ? void 0 : searchFromSegmentTable(textValue, langId)) !== null && _b !== void 0 ? _b : [];
    const projectScripts = (_c = searchFromProject === null || searchFromProject === void 0 ? void 0 : searchFromProject(textValue, langId)) !== null && _c !== void 0 ? _c : [];
    const prevScripts = (_d = searchFromPrevScripts === null || searchFromPrevScripts === void 0 ? void 0 : searchFromPrevScripts()) !== null && _d !== void 0 ? _d : [];
    const allWordScripts = [...projectScripts, ...prevScripts];
    const response = yield (0, api_1.prepareTranslation)({
        langId,
        text: textValue || "",
        projectId,
        controller,
    });
    const json = response.data;
    // TODO: 2024/3/14 Shōsei Yū:
    //  Here, if the request fails, the error is not handled and the value scripts may be another type.
    //  We need to fix this issue later.
    const { context: unfilteredScripts } = json;
    const scripts = unfilteredScripts.filter((item) => !isIdMatch(schema.ignoredReferenceTranslationIds || [], item.id));
    const ignoredScripts = unfilteredScripts.filter((item) => isIdMatch(schema.ignoredReferenceTranslationIds || [], item.id));
    const wordScripts = allWordScripts.filter((item) => !isIdMatch(schema.ignoredReferenceTranslationIds || [], item.id));
    const ignoredWordScripts = allWordScripts.filter((item) => isIdMatch(schema.ignoredReferenceTranslationIds || [], item.id));
    const exactMatchedScripts = wordScripts.filter((item) => item.text.trim() === textValue.trim());
    let processedText = textValue;
    let filteredScripts = scripts;
    if (useDirectWordReplacement) {
        // Split words based on whether they should be directly replaced
        const wordsToReplace = segmentTableScripts.filter((word) => (0, util_1.shouldReplaceDirectly)(word.translation));
        const wordsToReference = segmentTableScripts.filter((word) => !(0, util_1.shouldReplaceDirectly)(word.translation));
        // Apply direct replacement only for words that meet the criteria
        processedText = (0, util_1.applyWordListDirectly)(textValue, wordsToReplace);
        // Filter out scripts that match with directly replaced words
        filteredScripts = filteredScripts.filter((script) => !wordsToReplace.some((word) => word.text === script.text));
        // Add words that should be referenced but not directly replaced
        filteredScripts = [
            ...filteredScripts,
            ...wordsToReference.map((word) => ({
                text: word.text,
                translation: word.translation,
                id: `wordlist-${word.text}`,
                isWord: true,
            })),
        ];
    }
    // Apply the same filtering logic for both cases
    filteredScripts = (() => {
        if (ignoreExactMatchedReference) {
            if (exactMatchedScripts.length > 0) {
                const notExactMatchedScripts = filteredScripts.filter((item) => item.text.trim() !== textValue.trim());
                return [...(wordScripts || []), ...notExactMatchedScripts];
            }
            else {
                return [...(wordScripts || []), ...filteredScripts];
            }
        }
        else {
            return [...(wordScripts || []), ...filteredScripts];
        }
    })();
    const context = {
        scripts: filteredScripts,
        ignoredScripts,
        wordScripts,
        ignoredWordScripts,
        exactMatchedScripts,
        processedText,
        exactMatched: exactMatchedScripts.length > 0,
        ignoreExactMatchedReference,
    };
    callback === null || callback === void 0 ? void 0 : callback(context);
    return context;
});
exports.getContextPromise = getContextPromise;
const CopilotSchemaComponent = (props) => {
    var _a, _b;
    const [focus, setFocus] = react_1.default.useState(false);
    const alert = (0, standard_1.useAlert)();
    const { value, registerProps, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    const modalFormFullScreen = (0, standard_1.useModalFormFullScreen)();
    const { field: textField } = (0, react_hook_form_1.useController)({
        name: "text",
        control: props.control,
    });
    const { value: textValue, onChange } = textField;
    const { schema } = props;
    const { langId, projectId, segmentId, scriptId, autoSaveHandler } = schema;
    const { list: comments } = (0, models_hook_1.useCommentList)({
        projectId,
        segmentId,
        scriptId,
    });
    const commentsForScript = ((_a = comments === null || comments === void 0 ? void 0 : comments.filter((comment) => !comment.resolved)) !== null && _a !== void 0 ? _a : []).sort((a, b) => b.createdAt - a.createdAt);
    const containerRef = react_1.default.useRef(null);
    const copilot = react_1.default.useRef();
    const [context, setContext] = react_1.default.useState();
    const searchFromProject = (0, wordTable_1.useProjectWordTable)(projectId);
    const searchFromSegmentTable = (0, wordTable_1.useScriptBasedWordTable)(projectId, segmentId);
    const searchFromPrevScripts = (0, wordTable_1.usePrevScripts)(projectId, segmentId, langId);
    const { data: projectData } = (0, models_hook_1.useProjectDoc)({ projectId });
    const nextScriptHandler = (0, shortcutHandler_1.useShortcutHandler)("SaveAndNextScript");
    (0, hooks_1.useHotkeys)([["mod + ArrowRight", nextScriptHandler, { preventDefault: true }]], [], true);
    const { list: scriptList } = (0, models_hook_1.useReactiveScriptList)({
        projectId,
        segmentId,
    });
    const [, setPreviousScriptId] = react_1.default.useState("");
    (0, react_1.useEffect)(() => {
        // setContext(undefined);
        if (!containerRef.current) {
            console.log("containerRef.current is null");
            return;
        }
        if (!textValue || !langId)
            return;
        const contextPromise = (() => __awaiter(void 0, void 0, void 0, function* () {
            return (0, exports.getContextPromise)({
                searchFromProject,
                searchFromSegmentTable,
                langId,
                projectId,
                schema: projectData,
                textValue,
                callback: setContext,
                searchFromPrevScripts: searchFromPrevScripts === null || searchFromPrevScripts === void 0 ? void 0 : searchFromPrevScripts(scriptId),
            });
        }))();
        const copilotEngine = new copilot_js_1.CopilotEngine({
            textOnly: false,
            onChange: registerProps.onChange,
            handler: (params) => {
                return (0, exports.callCompletion)(Object.assign(Object.assign({}, params), { contextPromise, text: textValue || "", langId,
                    projectId, prompt: projectData === null || projectData === void 0 ? void 0 : projectData.translationPrompt }));
            },
            errorHandler: (e) => {
                const { data } = JSON.parse(JSON.stringify(e));
                if (data.detail && data.detail.status === 404) {
                    alert({
                        message: `選択したモデルは利用できません`,
                    });
                }
                else if (data.detail && data.detail.status === 429) {
                    const matcher = data.detail.message.match(/Please retry after (\d+) second/);
                    const timeToWait = matcher ? parseInt(matcher[1], 10) : 60;
                    alert({
                        message: `Open AIのクオータ制限のため、${timeToWait}秒待機してから再開します`,
                    });
                }
                else {
                    alert({
                        message: `エラーが発生しました。もう一度お試しください。`,
                    });
                }
            },
            value,
            element: containerRef.current,
        });
        copilot.current = copilotEngine;
        setPreviousScriptId((cur) => {
            var _a;
            if (cur === schema.scriptId)
                return cur;
            (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            return schema.scriptId;
        });
        return () => {
            copilotEngine.close();
        };
    }, [
        textValue,
        langId,
        containerRef.current,
        searchFromSegmentTable,
        searchFromProject,
        projectData,
        schema.scriptId,
        scriptList,
        searchFromPrevScripts,
    ]);
    const setTranslation = (0, react_1.useCallback)((translation) => {
        var _a;
        if (containerRef.current)
            containerRef.current.innerText = translation;
        registerProps.onChange(translation);
        (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    const setSidePanelKind = (0, components_1.useSetSidePanelKind)();
    const handleBlur = () => {
        fieldState.isDirty && (autoSaveHandler === null || autoSaveHandler === void 0 ? void 0 : autoSaveHandler());
        setFocus(false);
    };
    const formContext = (0, react_hook_form_1.useFormContext)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(standard_1.FieldWrapper, { fieldState: fieldState, loading: props.schema.showSpinner &&
                fieldState.isDirty &&
                ((_b = formContext === null || formContext === void 0 ? void 0 : formContext.formState) === null || _b === void 0 ? void 0 : _b.isSubmitting) },
            react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)("form-control", {
                    "has-error": fieldState.invalid,
                }, "enableScrollbar") }, registerProps, { ref: containerRef, style: {
                    height: "158px",
                    overflowY: "auto",
                    resize: "vertical",
                }, tabIndex: 0, onBlur: handleBlur, onFocus: () => {
                    setFocus(true);
                } })),
            react_1.default.createElement("div", { style: {
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                } },
                react_1.default.createElement(components_1.SidePanelLink, { sidePanelKind: "reference-translation" },
                    react_1.default.createElement("i", { className: "mdi mdi-book-open-variant", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u53C2\u7167\u8A33\u3092\u8868\u793A\u3059\u308B" })),
                react_1.default.createElement(components_1.SidePanelLink, { sidePanelKind: "proof-reading" },
                    react_1.default.createElement("i", { className: "mdi mdi-card-search-outline", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u6821\u95B2" })),
                react_1.default.createElement(components_1.SidePanelLink, { sidePanelKind: "multiple-translations" },
                    react_1.default.createElement("i", { className: "mdi mdi-format-list-bulleted-type", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u8907\u6570\u7FFB\u8A33" })),
                react_1.default.createElement(components_1.SidePanelLink, { sidePanelKind: "translation-settings" },
                    react_1.default.createElement("i", { className: "mdi mdi-cog", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u7FFB\u8A33\u8A2D\u5B9A" })),
                react_1.default.createElement(components_1.SidePanelLink, { sidePanelKind: "KeyboardGuide" },
                    react_1.default.createElement("i", { className: "mdi mdi-help", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u30AD\u30FC\u64CD\u4F5C\u4E00\u89A7" })),
                commentsForScript.length >= 0 && (react_1.default.createElement(components_1.SidePanelLink, { sidePanelKind: "comments" },
                    react_1.default.createElement("i", { className: (0, classnames_1.default)("mdi", commentsForScript.length
                            ? "mdi-comment-multiple"
                            : "mdi-comment-multiple-outline"), "data-tooltip-id": "tooltip", "data-tooltip-html": commentsForScript.length
                            ? `未解決コメント：${commentsForScript.length}<br/>
                    最後のコメント：` +
                                commentsForScript[0].comment
                                    .map((comment) => comment.content)
                                    .join("") || ""
                            : "コメントを追加する" }),
                    react_1.default.createElement("span", { style: { fontSize: "0.8em" } }, commentsForScript.length
                        ? commentsForScript.length
                        : undefined))),
                (schema === null || schema === void 0 ? void 0 : schema.count) && (react_1.default.createElement(standard_1.LengthDisplay, { value: value === null || value === void 0 ? void 0 : value.length, active: focus }))),
            react_1.default.createElement(components_1.SidePanel, { title: react_1.default.createElement("i", { className: "mdi mdi-book-open-variant", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u53C2\u7167\u8A33\u3092\u8868\u793A" }), kind: "reference-translation" },
                react_1.default.createElement("section", { className: "sidePanelTitle" },
                    "\u53C2\u7167\u8A33",
                    react_1.default.createElement("p", { className: "sidePanelSubtitle" },
                        "\u5B8C\u5168\u4E00\u81F4\u3059\u308B\u53C2\u7167\u8A33\u304C\u3042\u308B\u305F\u3081\u3001\u3053\u306E\u8A33\u304C\u7FFB\u8A33\u3068\u3057\u3066\u63A1\u7528\u3055\u308C\u3066\u3044\u307E\u3059\u3002 \u7FFB\u8A33\u306E\u54C1\u8CEA\u3092\u8A55\u4FA1\u3059\u308B\u305F\u3081\u306B\u3001\u3053\u306E\u8A2D\u5B9A\u3092\u5909\u66F4\u3059\u308B\u5834\u5408\u306F\u3001",
                        react_1.default.createElement(components_1.SidePanelLink, { sidePanelKind: "translation-settings" }, "\u7FFB\u8A33\u8A2D\u5B9A"),
                        "\u304B\u3089\u4FEE\u6B63\u3057\u3066\u304F\u3060\u3055\u3044\u3002")),
                react_1.default.createElement(CopilotContextList_1.CopilotContextList, { context: context !== null && context !== void 0 ? context : null, projectId: projectId, diffOriginal: textValue, diffTranslated: value, langId: langId, onApply: setTranslation })),
            react_1.default.createElement(components_1.SidePanel, { title: react_1.default.createElement("i", { className: "mdi mdi-card-search-outline", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u6821\u95B2" }), kind: "proof-reading" },
                react_1.default.createElement("section", { className: "sidePanelTitle" }, "\u6821\u95B2(\u03B2\uFF09"),
                context && (react_1.default.createElement(Proofreading_1.Proofreading, { text: textValue || "", translation: value || "", langId: langId, context: context.scripts, prompt: projectData === null || projectData === void 0 ? void 0 : projectData.proofreadingPrompt, projectId: projectId }))),
            react_1.default.createElement(components_1.SidePanel, { title: react_1.default.createElement("i", { className: "mdi mdi-format-list-bulleted-type", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u8907\u6570\u7FFB\u8A33" }), kind: "multiple-translations" },
                react_1.default.createElement("section", { className: "sidePanelTitle" }, "\u8907\u6570\u7FFB\u8A33"),
                context && (react_1.default.createElement(AnotherTranslationList_1.AnotherTranslationList, { text: textValue || "", langId: langId, context: context.scripts, prompt: projectData === null || projectData === void 0 ? void 0 : projectData.translationPrompt, description: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u9069\u7528\u3002", projectId: projectId, onApply: setTranslation }))),
            react_1.default.createElement(components_1.SidePanel, { title: react_1.default.createElement("i", { className: "mdi mdi-cog", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u8A2D\u5B9A" }), kind: "translation-settings" },
                react_1.default.createElement(CopilotSetting_1.CopilotSetting, null)),
            react_1.default.createElement(components_1.SidePanel, { title: react_1.default.createElement("i", { className: "mdi mdi-help", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u30AD\u30FC\u64CD\u4F5C\u4E00\u89A7" }), kind: "KeyboardGuide" },
                react_1.default.createElement("section", { className: "sidePanelTitle" }, "\u30AD\u30FC\u64CD\u4F5C\u4E00\u89A7"),
                react_1.default.createElement("div", { style: { padding: "10px" } },
                    react_1.default.createElement(showKeyboard_1.KeyboardGuide, null))))));
};
CopilotSchemaComponent.display = (0, standard_1.DisplayComponent)("CopilotDisplayComponent", (value) => {
    return react_1.default.createElement("div", { style: { whiteSpace: "pre-wrap" } }, value);
});
exports.default = CopilotSchemaComponent;
const callCompletion = ({ text, precedingText, followingText, projectId, callback, contextPromise, langId, prompt, }) => {
    const filter = (0, util_1.createFilter)(callback, !!precedingText);
    const controller = new AbortController();
    try {
        if (!text) {
            throw new Error("text is empty");
        }
        const copilotMode = localStorage.getItem("COPILOT_MODE") || "api";
        if (copilotMode === "api") {
            const emitter = new events_1.default();
            return {
                abort() {
                    emitter.emit("abort");
                },
                promise: (() => __awaiter(void 0, void 0, void 0, function* () {
                    const context = yield contextPromise;
                    if (!context)
                        return;
                    if (context.exactMatched &&
                        !context.ignoreExactMatchedReference &&
                        !precedingText) {
                        const script = context.scripts.find((script) => {
                            return script.text.trim() === text.trim();
                        });
                        script && callback(script.translation);
                        return;
                    }
                    const model = (0, CopilotSetting_1.getCopilotSetting)().translationModel;
                    const matchedContext = context.scripts.find((c) => c.translation && c.text && c.text === text);
                    if (matchedContext && matchedContext.translation) {
                        callback(matchedContext.translation);
                        return;
                    }
                    const responsePromise = (0, api_1.chatCompletionWithContext)({
                        model,
                        context: context.scripts,
                        params: {
                            text: context.processedText,
                            langId,
                            precedingText,
                        },
                        prompt: Object.assign(Object.assign({}, api_1.defaultTranslationPrompt), prompt),
                    });
                    const streamState = (0, fromFetchSSEStream_1.fromFetchSSEStream)({
                        callback: (data) => {
                            if (data.error) {
                                console.error(data.error);
                                alert(`翻訳失敗 (${data.error.message})`);
                                return;
                            }
                            // ストリームの最後のチャンクでトークン使用量を報告
                            // 通常、usageはストリームの最後のチャンクで提供される
                            if (data.usage) {
                                (0, reportTokenUsage_1.reportTokenUsage)(model !== null && model !== void 0 ? model : "unknown", data.usage.prompt_tokens, data.usage.completion_tokens, projectId).catch(console.error);
                            }
                            if (data.choices.length === 0)
                                return;
                            filter(data.choices[0].delta.content || "");
                        },
                        controller,
                        responsePromise,
                    });
                    emitter.on("abort", () => {
                        streamState.abort();
                    });
                    yield streamState.promise;
                }))(),
            };
        }
        throw new Error("invalid copilot mode");
    }
    catch (e) {
        console.error("Translation error:", e);
        throw e;
    }
};
exports.callCompletion = callCompletion;
